// Vendors
import React, { useState } from 'react';

// Components
import { Reply } from '../../../../components';

const DirectMessage = ({
  IS_ADMIN,
  admin_initiated,
  id,
  subject,
  body,
  date,
  replies,
  new_replies,
  unread,
  loading,
  dmTabIDOpen,
  setDmTabIDOpen,
  postDMReply,
  builder,
  handleMarkAsRead
}) => {
  const [open, setOpen] = useState();
  const [newMessage, setNewMessage] = useState('');

  return (
    <div className="u--display-block u--margin-bottom-20">
      <button
        className={`btn btn--white btn--pip-accordion module-hover-root ${
          dmTabIDOpen === id ? 'btn--pip-accordion--on' : ''
        } ${subject.length > 100 ? 'btn--md' : 'btn--lg'}`}
        type="button"
        onClick={() => {
          setDmTabIDOpen(dmTabIDOpen === id ? 0 : id);
          setOpen(!open);
        }}
      >
        <span className="btn__content">
          <span className="btn__text">
            {IS_ADMIN && (
              <>
                <span>{admin_initiated != '0' ? '[ADMIN] ' : ''}</span>
                <span>{builder.user_email} &mdash; </span>
              </>
            )}
            <span
              dangerouslySetInnerHTML={{
                __html:
                  subject.length >= 121
                    ? `${subject.slice(0, 121)}...`
                    : subject
              }}
            />
            {(new_replies > 0 || unread === true) && (
              <span className="btn__text--message-count">
                {new_replies == 0
                  ? parseInt(new_replies) + 1
                  : parseInt(new_replies)}
              </span>
            )}
          </span>
          <span className="btn__arrow"></span>
        </span>
      </button>

      <div
        className={
          dmTabIDOpen === id
            ? 'u--display-block u--padding-top-20 u--squash-end u--padding-bottom-10'
            : 'u--display-none'
        }
      >
        <div className="u--display-flex u--flex-direction-row">
          <small
            className="u--display-block u--margin-bottom-5"
            style={{ flexBasis: '50%' }}
          >
            {date} {admin_initiated != '0' ? ' — by Admin' : ''}
          </small>
          <div className="u--text-align-right" style={{ flexBasis: '50%' }}>
            {new_replies > 0 ||
              (unread && (
                <button
                  type="button"
                  className="u--align-self--top u--justify-self-flex-end btn btn--md btn--blue btn--link module-hover-root"
                  onClick={() => handleMarkAsRead(id)}
                >
                  <span className="btn__content" style={{ lineHeight: '20px' }}>
                    <span className="btn__text">Mark as read</span>
                  </span>
                </button>
              ))}
          </div>
        </div>
        <p
          className="u--font-size-lg u--margin-bottom-50"
          dangerouslySetInnerHTML={{ __html: body }}
        />
        {replies &&
          replies.map((reply, index) => <Reply key={index} {...reply} />)}
        <div className="direct-message__container">
          <div className="direct-message__new-comment">
            <div
              className="form__field u--margin-bottom-30"
              style={{
                maxWidth: '600px',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              <textarea
                type="textarea"
                className="form__textarea form__textarea--no-shadow u--margin-bottom-20"
                value={newMessage}
                onChange={(event) => setNewMessage(event.target.value)}
              />
              <button
                className={`u--margin-right-10 btn btn--gold ${
                  loading ? 'btn--loading' : ''
                }`}
                type="button"
                disabled={!newMessage}
                onClick={() => postDMReply(newMessage, id)}
              >
                <span className="btn__content">
                  <span className="btn__text">Reply</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DirectMessage;
